import { IDataProspecto } from "../prospecto";

export interface ISolicitudTutorDescuentoPagingRes {
  count: number;
  next: null;
  previous: null;
  numero_paginas: number;
  data: SolicitudTutorDescuento[];
}
export interface SolicitudTutorDescuento {
  id_solicitud_tutor_descuento: string,
  estado?: boolean,
  codigo?: string,
  numero_referencia?: string,
  observaciones?: { [key: string]: string } | null,
  estado_solicitud?: string,
  prospecto?: string,
  user_create?: string,
  empresa_create?: string,
  area_create?: string,
  departamento_create?: string,
  canal_venta_create?: string,
  user_aprueba?: string,
  es_bono_humano?: boolean,
  es_tutor?: boolean,
  es_ayuda_social?: boolean
  es_reportado?: boolean
  es_gremio?: boolean
  fecha_creacion?: string,
  fecha_modificacion?: string,
  prospecto_data?: IDataProspecto,
}


/* export type SaveSolicitudTutorDescuentoFormData = {
  id_solicitud_tutor_descuento:string,
  estado: boolean,
  codigo: string,
  numero_referencia: string,
  observaciones: {[key:string]:any},
  estado_solicitud: string,
  prospecto: string,
  user_create: string,
  empresa_create: string,
  area_create: string,
  departamento_create: string,
  canal_venta_create: string,
  user_aprueba: string,
  es_bono_humano:string,
  es_tutor:string,
  fecha_creacion:string,
  fecha_modificacion:string,
};
 */



/* export interface ISolicitudTutorDescuentoRows  {
  id_solicitud_tutor_descuento:string,
  estado: boolean,
  codigo: string,
  numero_referencia: string,
  observaciones: {[key:string]:any},
  estado_solicitud: string,
  prospecto: string,
  user_create: string,
  empresa_create: string,
  area_create: string,
  departamento_create: string,
  canal_venta_create: string,
  user_aprueba: string,
  es_bono_humano:boolean,
  es_tutor:string,
  fecha_creacion:string,
  fecha_modificacion:string,
  prospecto_data?:IDataProspecto,
} */

export interface SolicitudTutorDescuentoForm extends Partial<SolicitudTutorDescuento> {
  observacion_score_bajo?: string
  observacion_reportado?: string
  observacion_solicitud?: string
  url_foto_tutor_discapacidad?: string
  url_foto_documento_legal_representante?: string
  url_foto_bono_desarrollo_humano?: string
  identificacion_carga_personal?: string
  razon_social_carga_personal?: string
  razon_social?: string
  identificacion?: string
  celular?: string
  es_reportado?: boolean
  segmentacion?: string
  puntaje_score?: string
  puntaje_score_empresa?: string
  puntaje_score_sobreendeudamiento?: string
  url_foto_identificacion_personal_gremio?: string
  url_foto_credencial_empresa?: string
  url_foto_documento_legal_empresa?: string
  //observacion_eva?: string
  observacion_supervisor?: string
}

export enum SolicitudTutorDescuentoEstadoSolicitudEnum {
  EN_ESPERA = 'EN ESPERA',
  APROBADO = 'APROBADO',
  RECHAZADO = 'RECHAZADO', // CUANDO ES TRANSFERENCIA O EFECTIVO
}

export type BeneficiosValues = {
  es_tutor?: boolean;
  es_bono_humano?: boolean;
  es_gremio?: boolean;
  es_reportado?: boolean;
  es_ayuda_social?: boolean
  //es_curador_tutor: boolean
  reportado?: boolean
};

export type ProspectoTutorDescuento = {
  codigo: string
  estado_solicitud: string
  prospecto: {
    es_ayuda_social: boolean
    es_bono_humano: boolean
    es_curador_tutor: boolean
    es_discapacitado: boolean
    es_gremio: boolean
    es_reportado: boolean
    reportado: boolean
  }
}